import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewAmenitiesList = (amenityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_AMENITIES_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/amenity/list`,
        amenityData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_AMENITIES_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_AMENITIES_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_AMENITIES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewSubAmenitiesList = (amenityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_SUB_AMENITIES_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/amenity/list`,
        amenityData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SUB_AMENITIES_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SUB_AMENITIES_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_SUB_AMENITIES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewAmenity = (amenityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_AMENITY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/amenity/${amenityData}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_AMENITY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_AMENITY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_AMENITY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewAmenities = (amenityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_AMENITIES_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/amenity/add`,
        amenityData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_AMENITIES_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_AMENITIES_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      const errorData = error?.response?.data || {
        statusCode: 500,
        message: "Something went wrong",
      };
      dispatch({
        type: "ADD_AMENITIES_FAILED",
        payload: errorData,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editAmenities = (amenityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_AMENITIES_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/amenity/update`,
        amenityData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_AMENITIES_SUCCESS", payload: data });
        toast.success("Edit Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_AMENITIES_FAILED", payload: data });
        toast.error("Something Went Wrong!");
      }
    } catch (error) {
      dispatch({
        type: "EDIT_AMENITIES_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
